export default __webpack_public_path__ + "static/media/mentorship.e8cea79d.jpg";